import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { API_BASE_URL } from '@synergy/config';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { nullIfEmpty } from '@synergy/utils';

import { SettingsApi } from '../api/settings';
import { SystemNotification } from '../models/notifications';

const api = new SettingsApi(API_BASE_URL);

export const clearCache = createAsyncThunk('app-settings/clearCache', async (_, thunkAPI) => {
    const response = await api.clearCache();
    if (response.success) {
        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.success('app.settings.system.emptyCache.success')));
    } else {
        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
    }
});

export const saveInternalSettings = createAsyncThunk(
    'app-settings/saveInternalSettings',
    async (
        params: {
            lobsterXmlOrderUrl: string;
            defaultCfpTextContract: string;
            defaultCfpTextBonus: string;
            statusScale?: Record<string, string> | null;
        },
        thunkAPI
    ) => {
        const response = await api.saveInternalSettings(
            nullIfEmpty(params.lobsterXmlOrderUrl),
            nullIfEmpty(params.defaultCfpTextContract),
            nullIfEmpty(params.defaultCfpTextBonus),
            params.statusScale ?? null
        );
        if (response.success) {
            thunkAPI.dispatch(
                Snackbar.enqueue(PoolNotification.success('app.settings.system.lobsterEndpoint.success'))
            );
        } else {
            thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    }
);

export const getInternalSettings = createAsyncThunk('app-settings/getInternalSettings', async (_, thunkAPI) => {
    const response = await api.getInternalSettings();
    if (response.success === false) {
        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        return null;
    }

    return response.result;
});

export const getSystemNotifications = createAsyncThunk('app-settings/getSystemNotifications', async (_, thunkAPI) => {
    const response = await api.getNotifications();
    if (response.success === false) {
        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        return null;
    }

    return response.result;
});

export const postNotification = createAsyncThunk(
    'app-settings/postSystemNotification',
    async (notification: SystemNotification, thunkAPI) => {
        const response = await api.postNotification(notification);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }

        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.success('app.settings.notification.addedNotification')));

        return response;
    }
);

export const deleteNotification = createAsyncThunk(
    'app-settings/deleteSystemNotification',
    async (id: number, thunkAPI) => {
        const response = await api.deleteNotification(id);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }

        return id;
    }
);

export const updateNotification = createAsyncThunk(
    'app-settings/updateSystemNotification',
    async (notification: SystemNotification, thunkAPI) => {
        const response = await api.patchNotification(notification);
        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            return null;
        }

        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.success('app.settings.notification.updatedNotification')));

        return response;
    }
);
